import {isRouteErrorResponse, useRouteError} from "react-router-dom";

export default function ErrorPage() {
    //TODO: Improve all of this
    const error = useRouteError();
    return (
        <div>
            <h1>Something went wrong!</h1>
            <pre>{
                isRouteErrorResponse(error) ?
                    JSON.stringify(error.data, null, 2) :
                    "Unknown error"
            }</pre>
        </div>
    )
}